import { render, staticRenderFns } from "./tranOrder.vue?vue&type=template&id=e98223ac&scoped=true&"
import script from "./tranOrder.vue?vue&type=script&lang=js&"
export * from "./tranOrder.vue?vue&type=script&lang=js&"
import style0 from "./tranOrder.vue?vue&type=style&index=0&id=e98223ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98223ac",
  null
  
)

export default component.exports